<div class="meetings-kpis">
  <button type="button" class="meetings-kpis__card" (click)="escolher.emit('proximas')">
    <span class="meetings-kpis__icon meetings-kpis__icon--green" aria-hidden="true">
      <i class="pi pi-calendar-clock"></i>
    </span>
    <span class="meetings-kpis__text">
      <strong>Próximas</strong>
      <span>{{ apoioProximas() }}</span>
    </span>
    <span class="meetings-kpis__number">{{ totalProximas() ?? '—' }}</span>
  </button>

  <button type="button" class="meetings-kpis__card" (click)="escolher.emit('bots')">
    <span class="meetings-kpis__icon meetings-kpis__icon--blue" aria-hidden="true">
      <i class="pi pi-microchip-ai"></i>
    </span>
    <span class="meetings-kpis__text">
      <strong>Bots agendados</strong>
      <span>Gravação automática</span>
    </span>
    <span class="meetings-kpis__number">{{ totalBots() ?? '—' }}</span>
  </button>

  <button type="button" class="meetings-kpis__card" (click)="escolher.emit('sem-deal')">
    <span class="meetings-kpis__icon meetings-kpis__icon--amber" aria-hidden="true">
      <i class="pi pi-link"></i>
    </span>
    <span class="meetings-kpis__text">
      <strong>Sem deal vinculado</strong>
      <span>Revise para manter o CRM em dia</span>
    </span>
    <span class="meetings-kpis__number">{{ totalSemDeal() ?? '—' }}</span>
  </button>
</div>
